import React, { Component } from "react";
import { connect } from "react-redux";
import MdDelete from "react-icons/lib/md/delete";
import {
  setErrors,
  clearErrors
} from "../../../../actions/error.js";
import {
  setAsset,
  updateAsset,
  deleteAsset
} from "../../../../actions/asset.js";
import Button from "../../../../common/button/Button.js";
import Input from "../../../../common/input/Input.js";
import FaPlus from "react-icons/lib/fa/plus";

import Row from "../../../../common/grid/Row";
import Col from "../../../../common/grid/Col";

import "./Assets.css";

class Assets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      showConfirm: false,
      confirmed: false,
      asset_id: null,
      asset_name: "",
      asset_description: "",
      asset_isLocal: null,
      delete: null,
      edit: false,
      assets: []
    };

    this.renderForm = this.renderForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onAddClick = this.onAddClick.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
    this.validate = this.validate.bind(this);
    this.renderAsset = this.renderAsset.bind(this);
    this.onUpdateClick = this.onUpdateClick.bind(this);
    this.showForm = this.showForm.bind(this);
  }

  handleInputChange(text, name) {
    this.setState({ [name]: text });
  }

  /**
   * Validate input
   */
  validate() {
    let errors = {};
    if (!this.state.asset_name) {
      errors["asset_name"] = ["Asset Name is required!"];
    }

    if (!this.state.asset_description) {
      errors["asset_description"] = ["Asset Description is required!"];
    }

    this.props.addErrors(errors);
    return Object.keys(errors).length === 0;
  }

  /**
   * Event handler for adding assets
   */
  onAddClick() {
    if (this.validate()) {
      // Emit action
      this.props.setAsset({
        name: this.state.asset_name,
        description: this.state.asset_description
      });

      // Reset state
      this.setState({ showForm: false, asset_name: "", asset_description: "" });
    }
  }

  /**
   * Click handler for asset box
   * (should run when an asset is clicked & display a form filled with current asset's data)
   * @param {object} asset
   */
  onEditClick(asset) {
    this.setState({
      showForm: true,
      edit: true,
      asset_id: asset.id,
      asset_name: asset.name,
      asset_description: asset.description,
      asset_isLocal: asset.hasOwnProperty("project_id") ? false : true
    });
  }

  /**
   * Event handler for edit form's save button's click
   */
  onUpdateClick() {
    // UPDATE ASSET
    const asset = {
      id: this.state.asset_id,
      isLocal: this.state.asset_isLocal,
      name: this.state.asset_name,
      description: this.state.asset_description
    };

    // Emit redux action
    this.props.updateAsset(asset);

    // Reset state
    this.setState({
      showForm: false,
      edit: false,
      asset_id: null,
      asset_name: null,
      asset_description: null,
      asset_isLocal: null
    });
  }

  /**
   * Click handler for delete button on asset
   * (display confirmation & save asset in state's delete prop)
   * @param {object} asset
   */
  onDeleteClick(asset) {
    this.setState({
      showConfirm: true,
      confirmed: false,
      delete: asset
    });
  }

  /**
   * Confirm the deletion
   * click handler for yes button in delete-confirmation
   */
  onDeleteConfirm() {
    this.props.deleteAsset(this.state.delete);
    this.setState({
      showForm: false,
      showConfirm: false,
      confirmed: false,
      delete: null
    });
  }

  /**
   * Render form for adding new asset
   */
  renderForm() {
    const { edit } = this.state;
    return (
      <Col _bottom-16 add-asset-form>
        <div>
          <label htmlFor="asset_name" className="key">
            asset name:
          </label>
          <Input
            ph="Name"
            name="asset_name"
            value={this.state.asset_name}
            onChange={this.handleInputChange}
          />
        </div>

        <div>
          <label htmlFor="asset_description" className="key">
            asset description:
          </label>
          <Input
            ph="Description"
            name="asset_description"
            value={this.state.asset_description}
            onChange={this.handleInputChange}
          />
        </div>

        <Row _gap-16 _no-grow>
          <Button
            className="btn-plain btn-red-text"
            onClick={() => this.setState({ showForm: false })}
          >
            Cancel
          </Button>
          <Button
            className="btn-green-text btn-plain"
            onClick={edit ? this.onUpdateClick : this.onAddClick}
          >
            Save
          </Button>
        </Row>
      </Col>
    );
  }

  /**
   * Render individual asset
   */
  renderAsset(asset, key) {
    return (
      <div
        className="asset"
        key={key}
        onClick={this.onEditClick.bind(this, asset)}
      >
        {asset.name}
        <Button
          className="btn-red btn-square"
          onClick={this.onDeleteClick.bind(this, asset)}
        >
          <MdDelete size={24} />
        </Button>
      </div>
    );
  }

  showForm() {
    this.setState({ showForm: true });
  }

  /**
   * Render asset list using the renderAsset method
   */
  renderList() {
    return (
      <div>
        <Button
          className="btn-square space-between btn-blue"
          onClick={this.showForm}
        >
          <FaPlus />
          <span>Add New Asset</span>
        </Button>
        {this.props.assets && (
          <div className="asset-list">
            {this.props.assets.map((a, i) => this.renderAsset(a, i))}
          </div>
        )}
        {/* {!(this.props.assets.length > 0) && (
          <span className="info-text">There are no assets!</span>
        )} */}
      </div>
    );
  }

  /**
   * Render confirm dialog for deleting an asset
   */
  renderConfirm() {
    return (
      <div className="delete-confirmation">
        The asset will be deleted permanently! Are you sure you want to proceed?
        <div className="buttons">
          <Button className="btn-green" onClick={this.onDeleteConfirm}>
            Yes
          </Button>

          <Button
            className="btn-blue"
            onClick={() =>
              this.setState({
                showConfirm: false,
                confirmed: false,
                delete: null
              })
            }
          >
            No
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { showForm, showConfirm } = this.state;
    return (
      <div className="assets-container">
        {showConfirm && this.renderConfirm()}
        {showForm && !showConfirm && this.renderForm()}
        {!showForm && !showConfirm && this.renderList()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  errors: state.errors,
  assets: state.asset.form
});

const mapDispatchToProps = {
  addErrors: errors => dispatch => dispatch(setErrors(errors)),
  emptyErrors: () => dispatch => dispatch(clearErrors()),
  setAsset: asset => dispatch => dispatch(setAsset(asset)),
  updateAsset,
  deleteAsset
};

export default connect(mapStateToProps, mapDispatchToProps)(Assets);



// WEBPACK FOOTER //
// ./src/components/main/projects/_common/Assets.js